module.exports = __webpack_public_path__ + "media/images/athletes/1105-4452fd3364e1ab51539b76df77107fbe.png";